import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { CorpCardComponent, CorpLoadingComponent } from "@corporate-tailwind/component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BusinessExceptionMessage } from "src/app/shared/model/business-exception.model";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { CorpTranslateService } from "@corporate-tailwind/translation";

@Component({
    selector: 'itsme-customer-exception-summary',
    imports: [CommonModule, TranslateModule, CorpLoadingComponent],
    templateUrl: './itsme-customer-exception-summary.component.html',
    animations: [ ]
})
export class ItsMeCustomerExceptionSummaryComponent implements OnInit, OnDestroy {
// customerDto: CustomerDto | null = null;
businessExceptionMessages: BusinessExceptionMessage[] | null = null;
// form: FormGroup | null = null;

    constructor(
        public _orderWizardService: OrderWizardService,
        private _translateService: TranslateService,
        private _corpTranslateService: CorpTranslateService
    ) {
        // this.customerDto = this._orderWizardService.getValue(x=>x.step03?.customerDto);
        this.businessExceptionMessages = this._orderWizardService.orderWizard$()?.step03?.businessExceptionMessages ?? null;

        // this.form = this._orderWizardService.formGroup;

        // console.log('eee', this._orderWizardService.formGroup);
    }


    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }


}